// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: "captionbrain-platform",
  storageBucket: "captionbrain-platform.appspot.com",
  messagingSenderId: "23855926332",
  appId: "1:23855926332:web:da2c479557350217214739",
  measurementId: "G-SKZ3LEKSFQ"
  
};

// Initialize Firebase

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const signInWithGooglePopup = () => signInWithPopup(auth, googleProvider);
//const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const provider_proz = new OAuthProvider('oidc.proz');
provider_proz.addScope('openid');
provider_proz.addScope('email');
provider_proz.addScope('profile');
